import * as constants from "../../Constants";
const initialState = {
  books: [],
};

export const bookReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.setAllShelfs:
      return {
        books: action.payload,
      };
    case constants.moveBookToShelf:
      if (state.books.length === 0) return state;
      const _books = [...state.books];
      let _pushNew = true;
      for (const book in _books) {
        if (_books[book].id === action.payload.id) {
          _books[book].shelf = action.payload.shelf;
          _pushNew = false;
        }
      }
      if (_pushNew === true) {
        _books.push(action.payload);
      }
      const books = _books.sort((a, b) => (a.title > b.title ? 1 : -1));
      return {
        books: books,
      };
    case constants.getInitialBooks:
      return {
        books: action.payload,
      };
    default:
      return state;
  }
};
